var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.22 220.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222221;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,223.5A110.11,110.11,0,1,1,223.5,113.38,110.24,110.24,0,0,1,113.39,223.5Zm0-211.87A101.76,101.76,0,1,0,215.15,113.38,101.87,101.87,0,0,0,113.39,11.63Z",
    transform: "translate(-3.28 -3.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.24,177.42H123V112.84h18l1.92-21.62H123V78.91c0-5.1,1-7.12,5.95-7.12h14V49.35H125.08c-19.18,0-27.84,8.46-27.84,24.63V91.22H83.83v21.89H97.24Z",
    transform: "translate(-3.28 -3.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/facebook2.297feb9f4bc340facc6e405c40daf404.svg";
export { ForwardRef as ReactComponent };